<template>
  <div class="layout-root">
    <!-- LOGO 固定在左上 -->
    <div class="logo-bar-fixed">
      <router-link to="/" class="logo-link" @click="goHome">
        <img src="/logo.png" alt="長發地產LOGO" class="logo-img" />
      </router-link>
    </div>

    <!-- 右上固定漢堡按鈕（獨立顯示，永遠可見） -->
    <div class="hamburger-bar-fixed">
      <button class="hamburger-btn" @click="toggleMenu" :class="{ 'active': isMenuOpen }">
        <span class="hamburger-line"></span>
        <span class="hamburger-line"></span>
        <span class="hamburger-line"></span>
      </button>
    </div>

    <header :class="{'sticky': isSticky, 'nav-hidden': !isSticky && !isMenuOpen, 'menu-header-transparent': isMenuOpen}"
            @mouseenter="navHover=true" @mouseleave="navHover=false">
      <div class="container-fluid py-3 d-flex align-items-center px-0 header-container">
        <nav class="ms-auto">
          <ul class="nav nav-with-hamburger">
            <li class="nav-item nav-link-item dropdown" :class="{ 'hidden': isMenuOpen }">
              <router-link class="nav-link" to="/about">關於長發</router-link>
            </li>
            <li class="nav-item nav-link-item dropdown" :class="{ 'hidden': isMenuOpen }">
              <a class="nav-link" href="#local" @click.prevent="goLocal" aria-label="前往在地深耕區塊">在地深耕</a>
              <div class="dropdown-menu" role="menu">
                <a href="https://lems.chuanhwa.com.tw/10707h/home.html" class="dropdown-item" target="_blank" rel="noopener noreferrer" title="桃園航空城市府一期官方網站">航空城市府一期</a>
                <a href="https://airport-city.caa.gov.tw/" class="dropdown-item" target="_blank" rel="noopener noreferrer" title="桃園航空城交通部官方網站">航空城交通部</a>
                <a href="https://urdb.tycg.gov.tw/News_Content.aspx?n=10682&s=1578540" class="dropdown-item" target="_blank" rel="noopener noreferrer" title="桃園捷運綠線都市發展計畫">捷運綠線</a>
                <a href="https://urdb.tycg.gov.tw/News_Content.aspx?n=10711&s=1058472" class="dropdown-item" target="_blank" rel="noopener noreferrer" title="台鐵中路站周邊土地開發計畫">台鐵中路站</a>
              </div>
            </li>
            <li class="nav-item nav-link-item dropdown" :class="{ 'hidden': isMenuOpen }">
              <router-link class="nav-link" to="/lesson">地產小學堂</router-link>
              <div class="dropdown-menu">
                <router-link to="/lesson" class="dropdown-item">全部文章</router-link>
                <router-link to="/lesson" class="dropdown-item">知識百科</router-link>
                <router-link to="/lesson" class="dropdown-item">新聞總覽</router-link>
              </div>
            </li>
            <li class="nav-item nav-link-item dropdown" :class="{ 'hidden': isMenuOpen }">
              <router-link class="nav-link" to="/links">相關連結</router-link>
            </li>
            <li class="nav-item nav-link-item dropdown" :class="{ 'hidden': isMenuOpen }">
              <a class="nav-link" href="#contact" @click.prevent="goContact">聯絡我們</a>
              <div class="dropdown-menu">
                <a href="#company-info" class="dropdown-item" @click.prevent="goCompanyInfo">公司資訊</a>
              </div>
            </li>
            <li class="nav-item">
              <button class="hamburger-btn" @click="toggleMenu" :class="{ 'active': isMenuOpen }">
                <span class="hamburger-line"></span>
                <span class="hamburger-line"></span>
                <span class="hamburger-line"></span>
              </button>
            </li>
          </ul>
        </nav>
      </div>
    </header>

    <!-- 全螢幕選單彈出視窗 -->
    <div class="menu-overlay" :class="{ 'active': isMenuOpen }" @click="closeMenu">
      <div class="menu-content" @click.stop>
        <div class="menu-header"></div>
        <div class="menu-sections">
          <div class="menu-buttons-row">
            <div class="menu-category">
              <router-link to="/about" class="menu-category-title-link" @click="closeMenu">
                <div class="menu-category-title">關於長發</div>
              </router-link>
            </div>
            <div class="menu-category">
              <a href="#local" class="menu-category-title-link" @click.prevent="goLocal" aria-label="前往在地深耕區塊">
                <div class="menu-category-title">在地深耕</div>
              </a>
              <nav class="menu-category-items" aria-label="在地深耕相關連結">
                <a href="https://lems.chuanhwa.com.tw/10707h/home.html" class="menu-category-item" target="_blank" rel="noopener noreferrer" title="桃園航空城市府一期官方網站">航空城市府一期</a>
                <a href="https://airport-city.caa.gov.tw/" class="menu-category-item" target="_blank" rel="noopener noreferrer" title="桃園航空城交通部官方網站">航空城交通部</a>
                <a href="https://urdb.tycg.gov.tw/News_Content.aspx?n=10682&s=1578540" class="menu-category-item" target="_blank" rel="noopener noreferrer" title="桃園捷運綠線都市發展計畫">捷運綠線</a>
                <a href="https://urdb.tycg.gov.tw/News_Content.aspx?n=10711&s=1058472" class="menu-category-item" target="_blank" rel="noopener noreferrer" title="台鐵中路站周邊土地開發計畫">台鐵中路站</a>
              </nav>
            </div>
            <div class="menu-category">
              <router-link to="/lesson" class="menu-category-title-link" @click="closeMenu">
                <div class="menu-category-title">地產小學堂</div>
              </router-link>
              <div class="menu-category-items">
                <router-link to="/lesson" class="menu-category-item" @click="closeMenu">全部文章</router-link>
                <router-link to="/lesson" class="menu-category-item" @click="closeMenu">知識百科</router-link>
                <router-link to="/lesson" class="menu-category-item" @click="closeMenu">新聞總覽</router-link>
              </div>
            </div>
            <div class="menu-category">
              <router-link to="/links" class="menu-category-title-link" @click="closeMenu">
                <div class="menu-category-title">相關連結</div>
              </router-link>
            </div>
            <div class="menu-category">
              <a href="#contact" class="menu-category-title-link" @click.prevent="goContact">
                <div class="menu-category-title">聯絡我們</div>
              </a>
            </div>
          </div>
        </div>
        <div class="menu-divider"></div>
        <div class="contact-info">  
            <div class="contact-item">地址：桃園市桃園區經國一路92號3樓</div>
            <div class="contact-item">電話：03-3568268</div>
            <div class="contact-item">傳真：03-3567286</div>
            <div class="contact-item">統一編號：60720160</div>
        </div>
        <div class="menu-spacer"></div>
      </div>
    </div>

    <!-- 頁面內容插槽 -->
    <router-view />
    
    <!-- 全域背景音樂按鈕 -->
    <AudioPlayer v-if="showAudioPlayer" />
  </div>
</template>

<script>
import AudioPlayer from './AudioPlayer.vue';

export default {
  name: 'AppLayout',
  components: {
    AudioPlayer
  },
  data() {
    return {
      isSticky: false,
      navHover: false,
      isMenuOpen: false,
      showAudioPlayer: true // 設為 true 顯示音樂播放器，false 則隱藏
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
    if (typeof window !== 'undefined' && window.history && 'scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      this.isSticky = window.scrollY > 50;
    },
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    },
    closeMenu() {
      this.isMenuOpen = false;
    },
    goHome() {
      this.closeMenu();
      // router-link 會處理路由跳轉，我們只需確保滾動到頂部
      this.$nextTick(() => {
        setTimeout(() => {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }, 100);
      });
    },
    goLocal() {
      this.closeMenu();
      const navigateAndScroll = () => {
        const target = document.querySelector('#local');
        if (!target) return;
        const headerEl = document.querySelector('header');
        const headerHeight = headerEl ? headerEl.getBoundingClientRect().height : 0;
        const targetTop = target.getBoundingClientRect().top + window.pageYOffset - headerHeight;
        window.scrollTo({ top: Math.max(0, targetTop), behavior: 'smooth' });
      };
      if (this.$route.path !== '/') {
        this.$router.push('/').then(() => {
          this.$nextTick(() => setTimeout(navigateAndScroll, 50));
        });
      } else {
        this.$nextTick(navigateAndScroll);
      }
    },
    goContact() {
      this.closeMenu();
      const navigateAndScroll = () => {
        const target = document.querySelector('#contact');
        if (!target) return;
        const headerEl = document.querySelector('header');
        const headerHeight = headerEl ? headerEl.getBoundingClientRect().height : 0;
        const targetTop = target.getBoundingClientRect().top + window.pageYOffset - headerHeight;
        window.scrollTo({ top: Math.max(0, targetTop), behavior: 'smooth' });
      };
      if (this.$route.path !== '/') {
        this.$router.push('/').then(() => {
          this.$nextTick(() => setTimeout(navigateAndScroll, 50));
        });
      } else {
        this.$nextTick(navigateAndScroll);
      }
    },
    goCompanyInfo() {
      this.closeMenu();
      const navigateAndScroll = () => {
        const target = document.querySelector('#company-info');
        if (!target) return;
        const headerEl = document.querySelector('header');
        const headerHeight = headerEl ? headerEl.getBoundingClientRect().height : 0;
        const targetTop = target.getBoundingClientRect().top + window.pageYOffset - headerHeight;
        window.scrollTo({ top: Math.max(0, targetTop), behavior: 'smooth' });
      };
      if (this.$route.path !== '/') {
        this.$router.push('/').then(() => {
          this.$nextTick(() => setTimeout(navigateAndScroll, 50));
        });
      } else {
        this.$nextTick(navigateAndScroll);
      }
    }
  }
}
</script>

<style scoped>
header {
  transition: background 0.3s, box-shadow 0.3s, opacity 0.3s;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
  background: transparent;
  opacity: 0.01;
  pointer-events: auto;
}
header.sticky,
header.nav-hidden:hover {
  background: #fff;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}
header:not(.nav-hidden) {
  background: #fff;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  opacity: 1;
}
.logo-link { display: flex; align-items: center; margin-right: 0; }
.logo-img { height: 48px; width: auto; margin-left: 0; transition: height 0.25s ease; }
nav { margin-left: auto; }
nav .nav-link { color: #333; font-weight: 500; transition: font-size 0.25s ease, padding 0.25s ease, color 0.2s ease; }
nav .nav-link:hover { color: #007bff; }
.dropdown { position: relative; }
.dropdown-menu {
  position: absolute; top: 100%; left: 0; background: #fff; box-shadow: none; border-radius: 0; border: none;
  padding: 8px 0; min-width: 160px; display: block; opacity: 0; visibility: hidden; pointer-events: none;
  transform: translateY(10px) scaleY(0.98); transform-origin: top;
  transition: opacity 0.25s cubic-bezier(.2,.7,.2,1), transform 0.25s cubic-bezier(.2,.7,.2,1), visibility 0.25s cubic-bezier(.2,.7,.2,1);
  z-index: 10002;
}
.dropdown:hover .dropdown-menu { opacity: 1; visibility: visible; pointer-events: auto; transform: translateY(0) scaleY(1); }
.dropdown-item { display: block; padding: 8px 16px; color: #000; text-decoration: none; white-space: nowrap; }
.dropdown-item:hover { background: rgba(0,0,0,0.04); color: #007bff; }
.nav-with-hamburger { margin-right: 0; }
.header-container { padding-right: 20px !important; min-height: 72px; transition: min-height 0.25s ease, padding 0.25s ease; }
.logo-bar-fixed { position: fixed; top: 16px; left: 32px; z-index: 10002; background: transparent; display: flex; align-items: center; transition: top 0.25s ease, left 0.25s ease; }
.hamburger-bar-fixed { position: fixed; top: 16px; right: 20px; z-index: 10003; display: block; }
.hamburger-btn { display: flex; flex-direction: column; justify-content: space-around; width: 60px; height: 40px; background: transparent; border: none; cursor: pointer; padding: 0; box-sizing: border-box; z-index: 10000; position: relative; margin-left: 30px; transition: width 0.25s ease, height 0.25s ease, margin-left 0.25s ease, transform 0.15s ease; }
.hamburger-line { display: block; width: 100%; height: 2px; background: #333; border-radius: 2px; transition: all 0.3s ease-in-out; transform-origin: center; }
.hamburger-btn.active .hamburger-line:nth-child(1) { transform: translateY(13px) rotate(20deg); }
.hamburger-btn.active .hamburger-line:nth-child(2) { opacity: 0; }
.hamburger-btn.active .hamburger-line:nth-child(3) { transform: translateY(-13px) rotate(-20deg); }
.nav-link-item.hidden { opacity: 0; visibility: hidden; transition: opacity 0.3s ease, visibility 0.3s ease; }
header.menu-header-transparent { background: transparent !important; box-shadow: none !important; }
.menu-overlay { position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0, 0, 0, 0.6); z-index: 9998; opacity: 0; visibility: hidden; transition: opacity 0.3s ease-in-out, visibility 0.3s ease-in-out; }
.menu-overlay.active { opacity: 1; visibility: visible; }
.menu-content { background: rgba(255, 255, 255, 0.8); width: 100%; height: 100%; position: relative; display: flex; flex-direction: column; transform: translateY(-100%); transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1); backdrop-filter: blur(5px); }
.menu-overlay.active .menu-content { transform: translateY(0); }
.menu-header { display: flex; justify-content: flex-end; padding: 30px 40px; border-bottom: 1px solid #eee; min-height: 80px; }
.menu-sections { padding: 50px 40px 40px 40px; display: flex; flex-direction: column; justify-content: flex-start; align-items: center; width: 100%; margin: 0 auto; }
.menu-buttons-row { display: flex; justify-content: space-between; align-items: flex-start; width: 90%; max-width: 1600px; gap: 40px; margin-bottom: 120px; }
.menu-category { flex: 1; display: flex; flex-direction: column; align-items: center; text-align: center; }
.menu-category-title { font-size: 1.4rem; font-weight: 600; color: #000; margin-bottom: 25px; text-shadow: 0 0 5px rgba(255, 255, 255, 0.8); }
.menu-category-title-link { text-decoration: none; transition: all 0.2s ease; }
.menu-category-title-link:hover .menu-category-title { color: #007bff; }
.menu-category-items { display: flex; flex-direction: column; gap: 12px; align-items: center; }
.menu-category-item { font-size: 1rem; color: #000; font-weight: 400; cursor: pointer; transition: all 0.2s ease; text-shadow: 0 0 3px rgba(255, 255, 255, 0.6); text-decoration: none; display: block; }
.menu-category-item:hover { color: #007bff; transform: translateX(5px); }
.menu-divider { height: 1.5px; background: #000; margin: 0 auto; width: 90%; max-width: 1600px; }
.contact-info { padding: 20px 0; display: flex; justify-content: space-between; align-items: center; gap: 8px; width: 90%; max-width: 1600px; margin: 0 auto; flex-wrap: nowrap; }
.menu-spacer { flex-grow: 1; }
.contact-item { font-size: 1.1rem; color: #000; font-weight: 500; text-shadow: 0 0 5px rgba(255, 255, 255, 0.6); flex: 1; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width: 0; }
.contact-item:first-child { text-align: left; }
.contact-item:nth-child(2), .contact-item:nth-child(3) { text-align: center; }
.contact-item:last-child { text-align: right; }
@media (max-width: 1080px) {
  .nav-link-item { display: none !important; }
  header .hamburger-btn { display: none !important; }
}
@media (max-width: 720px) {
  .logo-bar-fixed { top: 12px; left: 16px; }
  .logo-bar-fixed .logo-img, .logo-img, .logo-bar .logo-img { height: 36px; }
  .hamburger-btn { width: 48px; height: 32px; margin-left: 16px; }
  .hamburger-bar-fixed { top: 12px; right: 12px; }
  .hamburger-bar-fixed .hamburger-btn:active { transform: scale(0.94); }
  .hamburger-bar-fixed .hamburger-line { transition: transform 0.25s cubic-bezier(.2,.7,.2,1), width 0.2s ease, background 0.2s ease, opacity 0.2s ease; }
  .hamburger-bar-fixed .hamburger-btn.active .hamburger-line:nth-child(1) { transform: translateY(11px) rotate(25deg); width: 100%; }
  .hamburger-bar-fixed .hamburger-btn.active .hamburger-line:nth-child(2) { opacity: 0; }
  .hamburger-bar-fixed .hamburger-btn.active .hamburger-line:nth-child(3) { transform: translateY(-11px) rotate(-25deg); width: 100%; }
  nav .nav-link { font-size: 0.95rem; padding: 0.25rem 0.5rem; }
  .header-container { padding-right: 12px !important; min-height: 56px; }
  
  /* 選單內容調整 - 置中對齊 */
  .menu-header { 
    padding: 20px 20px; 
    min-height: 64px; 
    justify-content: center; 
  }
  
  .menu-sections { 
    padding: 30px 20px 20px 20px; 
    align-items: center; 
  }
  
  .menu-buttons-row { 
    flex-direction: column; 
    gap: 30px; 
    margin-bottom: 60px; 
    width: 100%; 
    align-items: center; 
  }
  
  .menu-category { 
    width: 100%; 
    align-items: center; 
  }
  
  .menu-category-title { 
    font-size: 1.2rem; 
    margin-bottom: 15px; 
    text-align: center; 
  }
  
  .menu-category-items { 
    align-items: center; 
    text-align: center; 
  }
  
  .menu-category-item { 
    font-size: 0.95rem; 
    text-align: center; 
  }
  
  /* 聯絡資訊改為垂直堆疊並置中對齊 */
  .contact-info { 
    flex-direction: column; 
    gap: 12px; 
    align-items: center;
    padding: 15px 20px;
  }
  
  .contact-item { 
    text-align: center !important; 
    font-size: 0.95rem;
    white-space: normal;
    width: 100%;
  }
  
  .menu-divider {
    width: 85%;
  }
}
</style>


